import apiClient from './client';
import type { Project, ActualProject, ProjectCatalog, PaginatedResponse, FilterParams } from '@/types';

export const projectApi = {
  getProjects: async (params?: FilterParams): Promise<PaginatedResponse<Project>> => {
    const response = await apiClient.get<PaginatedResponse<Project>>('/projects/', { params });
    return response.data;
  },

  getProject: async (id: number): Promise<Project> => {
    const response = await apiClient.get<Project>(`/projects/${id}`);
    return response.data;
  },

  getActiveProjects: async (company?: string, businessLine?: string): Promise<Project[]> => {
    const params: Record<string, string> = {};
    if (company) params.company = company;
    if (businessLine) params.business_line = businessLine;
    const response = await apiClient.get<Project[]>('/projects/active', { params });
    return response.data;
  },

  getProjectCatalog: async (params?: FilterParams & { year?: number }): Promise<ProjectCatalog> => {
    const response = await apiClient.get<ProjectCatalog>('/projects/catalog', { params });
    return response.data;
  },

  getActualProjects: async (): Promise<ActualProject[]> => {
    const response = await apiClient.get<ActualProject[]>('/projects/actual/projects');
    return response.data;
  },
};
